import { CallRole } from '@trinity/chat';

export const roleIsModeratorLike = (roleId: CallRole) => {
  return [
    CallRole.Scheduler,
    CallRole.ModeratorAttendee,
  ].includes(roleId);
};

export const roleIsRespondentLike = (roleId: CallRole) => {
  return [
    CallRole.Respondent,
    CallRole.PrimaryRespondent,
  ].includes(roleId);
};